import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1160,
      xl: 1440,
    },
  },
  palette: {
    primary: {
      main: '#2f9e7a',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#5ca7e6',
    },
    error: {
      main: '#d64b3b',
    },
    background: {
      default: '#fbfaf7',
      paper: '#ffffff',
    },
    text: {
      primary: '#1f2430',
      secondary: '#6a7280',
    },
  },
  typography: {
    fontFamily: "'Inter', 'Geist', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
  },
  shape: {
    borderRadius: 14,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          WebkitFontSmoothing: 'antialiased',
          MozOsxFontSmoothing: 'grayscale',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 12,
          minHeight: 44,
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          minWidth: 44,
          minHeight: 44,
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          minHeight: 44,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          minHeight: 44,
        },
      },
    },
    MuiBottomNavigationAction: {
      styleOverrides: {
        root: {
          minHeight: 56,
        },
      },
    },
  },
});

export default theme;
